import { createStore } from 'redux';
import { configureStore } from '@reduxjs/toolkit'
import mediaReducer from './mediaSlice'
import { toMovie, toShow } from './actions'

export default configureStore({
    reducer: {
        media: mediaReducer
    }
})
